import { jsx as h, jsxs as c } from "react/jsx-runtime";
import r from "classnames";
import { a as t } from "../../styled-qu50FBLM.mjs";
import { Svg as L, GElement as H, Path as v } from "./Elements.js";
const n = ({ fill: a }) => /* @__PURE__ */ c(H, { children: [
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M82.07 0H26.39l8.82 19h4.1l3.37 7.25L46.06 19h4.11L44 32.24h-2.63l12.86 27.68L67.39 31.6a6.94 6.94 0 1 1 2.49-9.6l-3.1 1.86a3.4 3.4 0 0 0-2.86-1.63 3.33 3.33 0 1 0 2.86 5l2 1.23 3-6.36v10.2H82V29h-6.54v-1.78h5.24V24h-5.24v-1.84H82v-3.32h-8.68zm-27 32.24h-3.8V19h3.8z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M10.38 31.59a3.6 3.6 0 0 0 1.52-3.12 4.45 4.45 0 0 0-.38-1.91 3.13 3.13 0 0 0-1-1.24 6.36 6.36 0 0 0-1.34-.74 9.19 9.19 0 0 0-1.46-.47c-.49-.11-.92-.22-1.32-.32a2.78 2.78 0 0 1-1-.43.73.73 0 0 1-.33-.65c0-.52.36-.83 1-.92a4.79 4.79 0 0 1 2 .16 5.11 5.11 0 0 1 1.52.65l1.82-2.65a8.57 8.57 0 0 0-5-1.41 5.81 5.81 0 0 0-3.7 1.19 3.63 3.63 0 0 0-1.52 3 3.94 3.94 0 0 0 .51 2.05A3.5 3.5 0 0 0 3 26a10.6 10.6 0 0 0 1.64.76 12.52 12.52 0 0 0 1.64.49 4 4 0 0 1 1.25.47.87.87 0 0 1 .49.74.79.79 0 0 1-.45.76 2.22 2.22 0 0 1-1.14.22A9.4 9.4 0 0 1 5 29.3a5.34 5.34 0 0 1-1.28-.4 2.62 2.62 0 0 1-.8-.5L1 31.19a9.54 9.54 0 0 0 5.47 1.48 6.57 6.57 0 0 0 3.9-1.08"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M23.6 22.16v-3.32H13.43v13.52H23.6v-3.32h-6.49v-1.82h5.24v-3.24h-5.24v-1.82h6.49z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M32.55 24.84a1.22 1.22 0 0 1-1 .52h-2.33v-3.2h2.35a1.22 1.22 0 0 1 1 .52 1.67 1.67 0 0 1 0 2.16m4.26-1.08a4.62 4.62 0 0 0-1.48-3.51 5.1 5.1 0 0 0-3.63-1.41h-6.19v13.52h3.69v-3.68H31l1.68 3.68h4.14l-2.29-4.54a4.8 4.8 0 0 0 2.33-4.06"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M79.34 39.32a3.69 3.69 0 0 0-1.93-.57c-.76 0-1.3.3-1.3.81s.59.65 1.4.78l.38.06c1.21.2 2.17.72 2.17 1.9 0 1.5-1.32 2.22-2.78 2.22a4.74 4.74 0 0 1-2.87-.89l.71-1.09a3.58 3.58 0 0 0 2.17.73c.75 0 1.34-.3 1.34-.82s-.49-.64-1.44-.79l-.43-.07c-1.2-.19-2.08-.72-2.08-1.94 0-1.42 1.26-2.15 2.71-2.15a4.81 4.81 0 0 1 2.6.72z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M84.32 40.82h-1.7v1.71c0 .59.31.8.7.8a1.81 1.81 0 0 0 .89-.31l.46 1a2.63 2.63 0 0 1-1.56.49c-1.16 0-1.76-.65-1.76-1.87v-1.82h-.91V39.7h.91v-1.4h1.27v1.4h1.7z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M89.82 44.39h-1.24v-.52a1.74 1.74 0 0 1-1.41.63 2.48 2.48 0 0 1 0-4.94 1.74 1.74 0 0 1 1.41.64v-.5h1.24zM86.19 42a1.22 1.22 0 1 0 1.22-1.29A1.21 1.21 0 0 0 86.19 42z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M94.38 40.82h-1.71v1.71c0 .59.31.8.71.8a1.81 1.81 0 0 0 .89-.31l.46 1a2.62 2.62 0 0 1-1.56.49c-1.16 0-1.76-.65-1.76-1.87v-1.82h-.91V39.7h.91v-1.4h1.27v1.4h1.71z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M99.62 42a4.07 4.07 0 0 1 0 .42h-3.36a1.13 1.13 0 0 0 1.21 1 1.92 1.92 0 0 0 1.19-.42l.74.81a2.87 2.87 0 0 1-2 .71 2.47 2.47 0 0 1-.06-4.94A2.27 2.27 0 0 1 99.62 42m-3.36-.43h2.08a1 1 0 0 0-2.08 0"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M80.57 47.25l-1 1A2.22 2.22 0 1 0 77.93 52a1.75 1.75 0 0 0 1.93-1.5h-1.73v-1.15h3.13v.38A3.29 3.29 0 0 1 78 53.24a3.52 3.52 0 1 1 2.61-6"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M87 50.77a2.55 2.55 0 1 1-2.55-2.47A2.45 2.45 0 0 1 87 50.77m-3.8 0a1.25 1.25 0 1 0 1.25-1.29 1.23 1.23 0 0 0-1.25 1.29"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M90.46 53.12H89l-1.86-4.7h1.38l1.22 3.36 1.23-3.36h1.34l-1.85 4.7z"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M97.11 50.76a4 4 0 0 1 0 .42h-3.37a1.14 1.14 0 0 0 1.21 1 1.89 1.89 0 0 0 1.19-.45l.74.81a2.88 2.88 0 0 1-2 .71 2.47 2.47 0 0 1-.06-4.94 2.27 2.27 0 0 1 2.29 2.47m-3.36-.43h2.08a1 1 0 0 0-1-.94 1 1 0 0 0-1.06.94"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M101.16 48.4l-.16 1.25a2.05 2.05 0 0 0-.77-.15.94.94 0 0 0-1 1.05v2.56h-1.29v-4.7h1.23v.52a1.48 1.48 0 0 1 1.32-.64 2 2 0 0 1 .66.1"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M106.28 50.13v3H105v-2.6c0-.68-.34-1-.92-1a1 1 0 0 0-1 1.06v2.57h-1.27v-4.74h1.23V49a1.58 1.58 0 0 1 1.39-.68 1.75 1.75 0 0 1 1.83 1.83"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M115 50.13v3h-1.26v-2.6c0-.68-.34-1-.92-1a1 1 0 0 0-1 1.06v2.57h-1.26v-2.63c0-.68-.34-1-.92-1a1 1 0 0 0-1 1.06v2.57h-1.27v-4.74h1.24V49a1.57 1.57 0 0 1 1.38-.68 1.79 1.79 0 0 1 1.56.8 1.9 1.9 0 0 1 3.45 1"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M120.48 50.76a3.41 3.41 0 0 1 0 .42h-3.34a1.14 1.14 0 0 0 1.21 1 1.9 1.9 0 0 0 1.19-.45l.74.81a2.88 2.88 0 0 1-2 .71 2.47 2.47 0 0 1-.06-4.94 2.27 2.27 0 0 1 2.29 2.47m-3.36-.43h2.08a1 1 0 0 0-2.08 0"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M125.77 50.13v3h-1.27v-2.6c0-.68-.34-1-.92-1a1 1 0 0 0-1 1.06v2.57h-1.27v-4.74h1.23V49a1.58 1.58 0 0 1 1.39-.68 1.75 1.75 0 0 1 1.83 1.83"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      fill: a,
      d: "M130.24 49.54h-1.7v1.72c0 .58.31.8.7.8a1.82 1.82 0 0 0 .89-.31l.46 1a2.63 2.63 0 0 1-1.56.5c-1.16 0-1.76-.66-1.76-1.87v-1.84h-.91v-1.12h.91V47h1.27v1.4h1.7z"
    }
  )
] }), m = ({ fill: a }) => /* @__PURE__ */ c(H, { children: [
  /* @__PURE__ */ h(
    v,
    {
      d: "M39.6016 33.6228H42.6155V23.0722H39.6016V33.6228ZM52.3615 33.1156C51.5532 33.5835 50.6144 33.8525 49.6127 33.8525C46.462 33.8525 43.9585 31.4754 43.9585 28.338C43.9585 25.2006 46.462 22.8234 49.6127 22.8234C51.6244 22.8234 53.3827 23.9071 54.3389 25.5106L51.8774 26.9875C51.4131 26.2284 50.5693 25.6929 49.6127 25.6929C48.1502 25.6929 46.9684 26.8894 46.9684 28.338C46.9684 29.7864 48.1502 30.9829 49.6127 30.9829C50.5693 30.9829 51.4131 30.4623 51.8774 29.6883L53.4989 30.6614L55.8383 25.6127V33.7171H63.9022V31.0816H58.7602V29.6351H62.914V27.0569H58.7602V25.6102H63.9022V22.9749H57.0608L64 8H19.8679L26.8522 23.0723H30.1085L32.7805 28.8383L35.4524 23.0723H38.7151L33.826 33.6228H31.741L41.9337 55.6188L52.3615 33.1156Z",
      fill: a,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      d: "M7.43362 33.4693C8.2357 32.8963 8.63681 32.0658 8.63681 30.9914C8.63681 30.4042 8.53653 29.9029 8.33611 29.4732C8.13542 29.0435 7.87776 28.7141 7.56245 28.4849C7.24754 28.2558 6.88934 28.0552 6.50271 27.8977C6.11594 27.7402 5.72918 27.6112 5.34255 27.5253C4.95579 27.4394 4.61193 27.3534 4.29689 27.2675C3.98184 27.1816 3.72392 27.067 3.53784 26.9238C3.35163 26.7805 3.2657 26.6086 3.28004 26.4082C3.29425 25.9927 3.56653 25.7493 4.08212 25.6777C4.59772 25.606 5.12778 25.649 5.67194 25.8065C6.21622 25.964 6.61733 26.136 6.87499 26.3221L8.32163 24.2167C7.26175 23.4719 5.92986 23.0996 4.32557 23.0996C3.16542 23.0996 2.19147 23.4146 1.38939 24.0448C0.587314 24.6751 0.186209 25.4628 0.186209 26.3938C0.186209 27.0241 0.315043 27.5683 0.587314 28.0266C0.859326 28.4849 1.18884 28.8286 1.58995 29.0579C1.99092 29.287 2.42059 29.4875 2.89328 29.6594C3.36597 29.8314 3.79564 29.9602 4.19674 30.0462C4.59772 30.1321 4.9271 30.2609 5.18503 30.4186C5.4427 30.5761 5.57166 30.7765 5.57166 31.0058C5.57166 31.2779 5.45704 31.4785 5.21359 31.6074C4.97013 31.7363 4.6693 31.7935 4.31123 31.7793C3.95316 31.7649 3.58074 31.722 3.20832 31.6503C2.8359 31.5786 2.49217 31.4785 2.19147 31.3352C1.89065 31.192 1.67588 31.063 1.56126 30.9342L0 33.1543C1.16028 33.9419 2.60679 34.3286 4.33992 34.3286C5.60035 34.3286 6.63154 34.0422 7.43362 33.4693Z",
      fill: a,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      d: "M17.6005 25.7349V23.0996H9.53658V33.8418H17.6005V31.2063H12.4585V29.7598H16.6121V27.1816H12.4585V25.7349H17.6005Z",
      fill: a,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ h(
    v,
    {
      d: "M25.4252 27.869C25.2103 28.1412 24.9526 28.2845 24.6518 28.2845H22.7898V25.7349H24.6518C24.9526 25.7349 25.2103 25.8782 25.4252 26.1504C25.6401 26.4225 25.7404 26.7089 25.7404 27.0097C25.7404 27.3105 25.6401 27.597 25.4252 27.869ZM28.8054 27.0097C28.8054 25.8926 28.4186 24.9615 27.631 24.2167C26.8433 23.472 25.8835 23.0996 24.7519 23.0996H19.8679V33.8418H22.7898V30.9198H24.1648L25.4968 33.8418H28.7768L26.9579 30.2324C28.1895 29.373 28.8054 28.2988 28.8054 27.0097Z",
      fill: a,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  )
] }), z = ({
  className: a = "",
  viewBox: V,
  $cssHelper: o = t,
  fill: e = "#f90",
  focusable: d,
  withoutStateGovernmentText: C = !1
}) => {
  const M = C ? "0 0 64 64" : "0 0 130.59 59.92";
  return /* @__PURE__ */ h(
    L,
    {
      className: r({ [a]: !!a }),
      viewBox: V ?? M,
      $cssHelper: o,
      role: "img",
      "aria-label": "Service Victoria Logo",
      focusable: !!d,
      "aria-hidden": !d,
      children: C ? /* @__PURE__ */ h(m, { fill: e }) : /* @__PURE__ */ h(n, { fill: e })
    }
  );
};
export {
  z as default
};
